import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, take } from 'rxjs';
import { MembershipStatus } from '../models/membership.status';
import { AppState } from '../state/appstate';
import * as groupsSelector from '../state/selectors/group.selector';

export const groupAccountingGuard: CanActivateFn = (route, state) => {
  const store: Store<AppState> = inject(Store<AppState>);
  const router = inject(Router);

  let groupId = route.paramMap.get('id');
  if (!groupId) {
    let parent = route.parent;
    while (parent) {
      groupId = parent.paramMap.get('id');
      if (groupId) break;
      parent = parent.parent;
    }
  }

  if (!groupId) {
    router.navigate(['/groups']);
    return false;
  }

  return combineLatest([
    store.select(groupsSelector.getGroupById(groupId)),
    store.select(groupsSelector.getMyRolesInGroup(groupId)),
  ]).pipe(
    take(1),
    map(([group, roles]) => {
      const active = group?.memberStatus === MembershipStatus.active;
      if (active && roles && (roles.admin === true || roles.treasurer === true || roles.management === true)) {
        return true;
      } else {
        router.navigate(['/groups', groupId]);
        return false;
      }
    })
  );
};
